export default __webpack_public_path__ + "static/media/DataRestore.e0e2e059.png";